import { Link } from "react-router-dom";
import "./7ds.css";
import characters from "../data/characters";

const SevenDS = () => {
  return (
    <div className="seven-container">
      <h1 className="seven-title">Characters Missing Skins</h1>

      <div className="grid">
        {characters.map((char) => (
          <Link key={char.id} to={`/7ds/${char.id}`} className="card">
            <img src={`/7ds/${char.id}.png`} alt={char.name} />
            <div className="card-name">{char.name}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SevenDS;